import { render, staticRenderFns } from "./Placemarks.vue?vue&type=template&id=f0b37d82&scoped=true&lang=pug&"
import script from "./Placemarks.vue?vue&type=script&lang=js&"
export * from "./Placemarks.vue?vue&type=script&lang=js&"
import style0 from "./Placemarks.vue?vue&type=style&index=0&id=f0b37d82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b37d82",
  null
  
)

export default component.exports